import { CardItem, CardsTabType } from 'components/pages/Card/model/types';
import { useCallback, useMemo, useState } from 'react';
import { useLocation, Location } from 'react-router-dom';

function getInitialTab(location: Location) {
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');
  if (type) {
    return type === 'mission' ? 'mission' : 'area';
  }
  const tabFromSessionStorage = sessionStorage.getItem('card-tab');
  if (tabFromSessionStorage) {
    return tabFromSessionStorage as CardsTabType;
  }
  return 'area';
}

export function useCardListStateModel() {
  const location = useLocation();
  const initialTab = useMemo(() => getInitialTab(location), [location]);

  const [tab, setTab] = useState<CardsTabType>(initialTab);

  const wrapSetTab = useCallback((newTab: CardsTabType) => {
    setTab(newTab);
    sessionStorage.setItem('card-tab', newTab);
  }, []);

  // 選択されたカードの情報を保持するstate
  const [selectedCard, setSelectedCard] = useState<CardItem | null>(null);

  // モーダルを表示するためのstate, モーダル内の画像のURLを保存するためのstate
  const [modalData, setModalData] = useState<CardItem | null>(null);

  // クリアカードの画像をクリックした時のイベントハンドラ
  const handleOpenModal = (data: CardItem) => {
    setModalData(data);
  };

  const handleCloseModal = () => {
    setModalData(null);
  };

  const handleReceiveClick = (card: CardItem) => {
    setSelectedCard(card);
  };

  const handleCloseReceiveDialog = () => {
    setSelectedCard(null);
  };

  return {
    tab,
    setTab: wrapSetTab,
    selectedCard,
    modalData,
    handleOpenModal,
    handleCloseModal,
    handleReceiveClick,
    handleCloseReceiveDialog,
  };
}
